// Sunny Nails Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('is-visible');
    });
  }, { threshold: 0.08 });
  reveals.forEach(el => observer.observe(el));

  // Quick add feedback
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const orig = this.textContent;
      this.textContent = '✓ Added to Cart';
      this.style.background = '#6B8E6B';
      setTimeout(() => {
        this.textContent = orig;
        this.style.background = '';
      }, 1800);
    });
  });

});
